/**
 * Admin write schema for the bulk-upsert PATCH on `/admin/website/settings`
 * (Phase 5 - CMS write API).
 *
 * Backed by AppConfigEntry rows whose key starts with `website.`. The
 * regex enforces that prefix so a settings PATCH cannot accidentally
 * stomp a non-website config key like `branding.appName`.
 */

import { z } from 'zod';

export const WebsiteSettingsEntrySchema = z.object({
  key: z
    .string()
    .regex(/^website\.[a-z0-9_.-]+$/u, 'Key must start with "website."')
    .max(120),
  value: z.union([z.string(), z.number(), z.boolean(), z.null()]),
  description: z.string().max(255).optional(),
  category: z.string().max(60).default('website'),
});
export type WebsiteSettingsEntry = z.infer<typeof WebsiteSettingsEntrySchema>;

export const UpdateWebsiteSettingsRequestSchema = z.object({
  entries: z.array(WebsiteSettingsEntrySchema).min(1).max(200),
});
export type UpdateWebsiteSettingsRequest = z.infer<typeof UpdateWebsiteSettingsRequestSchema>;
